import { createAction, props } from '@ngrx/store';

import { Event } from '@planone/bau365/util-fair-data';

export const eventOpened = createAction('[Event Page] Opened', props<{ eventUuid: string }>());

export const contributorPageOpened = createAction(
  '[Contributor Page] Contributor details opened',
  props<{ eventUuid: string; contactPersonIndex: string; fairId?: string }>()
);

export const eventLoadSucceeded = createAction('[Event API] Event load succeeded', props<{ event: Event }>());
export const eventsLoadSucceeded = createAction('[Event API] Events load succeeded', props<{ events: Event[] }>());
export const eventLoadFailed = createAction('[Event API] Event load failed', props<{ error: string }>());
export const eventsLoadFailed = createAction('[Event API] Events load failed', props<{ error: string }>());
